import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "@data-phone/react-resource-server-auth";

export const fetchIntegrationConfig = createAsyncThunk<
  { name: string; config: any }, 
  string,                        
  { rejectValue: string }        
>(
  "integrations/fetchIntegrationConfig",
  async (integrationName, { rejectWithValue }) => {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_API_BASE_URL}/integrations/${integrationName}/config`
      );

      return {
        name: integrationName,
        config: res?.data,
      };
    } catch (error: any) {
      console.error("❌ Failed to fetch integration config:", error);
      return rejectWithValue(error?.message || "Failed to fetch integration config");
    }
  }
);
